import { BaseService } from '../../infra/base.service'
import type { Entry } from './entry'
import type { EntriesRepository } from './entries.repository'

export class EntriesService extends BaseService<Entry> {
    constructor(private rep: EntriesRepository) {
        super(rep)
    }

    async upsert(dto: Partial<Entry>) {
        return await this.rep.upsert(dto)
    }
    async bulkUpsert(dto: Partial<Entry>[]) {
        return await this.rep.bulkUpsert(dto)
    }
    async getEntriesByCategoryAndCash(from: Date, to: Date, pos: boolean = false) {
        return await this.rep.getEntriesByCategoryAndCash(from, to, pos)
    }
    async getEntriesByCategoryAndAccrual(from: Date, to: Date, pos: boolean = false) {
        return await this.rep.getEntriesByCategoryAndAccrual(from, to, pos)
    }
}
